import { render, staticRenderFns } from "./OzelMenuRaporlama.vue?vue&type=template&id=cfe62d84&scoped=true"
import script from "./OzelMenuRaporlama.vue?vue&type=script&lang=ts"
export * from "./OzelMenuRaporlama.vue?vue&type=script&lang=ts"
import style0 from "./OzelMenuRaporlama.vue?vue&type=style&index=0&id=cfe62d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe62d84",
  null
  
)

export default component.exports